import { useQuery } from '@tanstack/react-query';

import { mediaManagerClient } from '@/lib/axios';
import { QueryConfig } from '@/lib/react-query';
import { PaginatedResponse, ParamsWithPagination } from '@/types/api';

import { ChannelRecordingFilters, ChannelRecordingType } from '../types';

import { channelRecordingsQueryKeys } from './query-keys';

export async function getChannelRecordings(
  params?: ParamsWithPagination<ChannelRecordingFilters>
): Promise<PaginatedResponse<ChannelRecordingType>> {
  return mediaManagerClient.get('/api/v1/channel_recordings', {
    params: {
      limit: params?.limit,
      offset: params?.offset,
      search: params?.search,
      channel__media_type: params?.channelMediaType,
      production_center_id__in: params?.productionCenterIdIn?.join(','),
      channel_id: params?.channelId,
      state: params?.state,
      gte: params?.gte,
      lte: params?.lte,
      updated_by__in: params?.updatedByIn?.join(','),
      recording_task_type__in: params?.recordingTaskTypeIn?.join(','),
    },
  });
}

type QueryFnType = typeof getChannelRecordings;

interface UseSegmentsParams {
  config?: QueryConfig<QueryFnType>;
  params?: ParamsWithPagination<ChannelRecordingFilters>;
}

export function useChannelRecordings({ config, params }: UseSegmentsParams = {}) {
  return useQuery({
    ...config,
    queryKey: channelRecordingsQueryKeys.list(params),
    queryFn: () => getChannelRecordings(params),
  });
}
